import React from 'react'
import SEO from "../../shared/components/atoms/seo/seo"
import Layout from "../../shared/components/organisms/layout/layout"
import siteUrl from '../../shared/utils/siteUrl';
import ContentDetailPromo from '../organisms/content-detail-promo/content-detail-promo';

const TemplatePromo = props => {
    const { pageContext } = props
    const { promo, slug } = pageContext

    return (
        <Layout>
            <SEO
                title={promo.metaTitulo}
                image={promo.metaImagen && promo.metaImagen.file.url}
                description={promo.metaDescripcion}
                slug={siteUrl + '/promociones/' + slug}
                meta={[{
                    name: 'robots',
                    content: 'index, follow'
                }]}
            />
            <ContentDetailPromo info={promo} />
        </Layout>
    )
}

export default TemplatePromo
